import { ENDPOINT, RELATIONSHIP } from '../utils/constants';
import { request } from '../utils/request';
const Liferay = window.Liferay;

export async function getLearningPaths(pageSize) {
	const data = await request({
		params: {
			fields: 'id,description,expertiseLevel,persona,title,position',
			pageSize,
			sort: 'position:asc',
		},
		url: `${ENDPOINT.LEARNING_PATHS}`,
	});

	return data.items;
}

export const getLearningPathTitle = async (id) => {
  const response = await Liferay.Util.fetch(
    `${ENDPOINT.LEARNING_PATHS}/${id}?fields=title,`
  );
  const data = await response.json();
  return data;
};

export async function getLearningPathById(learningPathId) {
	const response = await request({
		params: {
			nestedFields: RELATIONSHIP.LEARNING_PATHS_TO_LEARNING_PATHS_STEPS
		},
		url: `${ENDPOINT.LEARNING_PATHS}/${learningPathId}`
	})

	return response;
}